<mat-form-field
  appearance="outline"
  [color]="model.getAdditional('color', 'primary')"
  [formGroup]="group"
  [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
  [ngClass]="getClass('grid', 'control')"
>
  <ng-container *ngIf="model.label" ngProjectAs="mat-label">
    <mat-label [innerHTML]="model.label"></mat-label>
  </ng-container>

  <span *ngIf="model.prefix" matPrefix [innerHTML]="model.prefix"></span>
  <span [innerHTML]="displayInput" class="display-input-date"></span>
  <input
    matInput
    [matDatepickerFilter]="filterDate"
    [autofocus]="model.autoFocus"
    [formControlName]="model.id"
    [id]="id"
    [max]="maxDateOverride || maxDate"
    [matDatepicker]="matDatepicker"
    [min]="minDate"
    [name]="model.name"
    [ngClass]="getClass('element', 'control')"
    [placeholder]="model.placeholder"
    readonly
    [required]="model.required"
    (blur)="onBlur($event)"
    (dateChange)="onChange($event)"
    (dateInput)="onCustomEvent($event, 'dateInput')"
    (focus)="onFocus($event)"
    style="display: none"
  />

  <span *ngIf="model.suffix" matSuffix [innerHTML]="model.suffix"></span>

  <mat-hint *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>

  <mat-datepicker-toggle matSuffix [for]="matDatepicker">
    <mat-icon *ngIf="!matDatepicker.opened" matDatepickerToggleIcon class="material-icons">calendar_today</mat-icon>
    <mat-icon *ngIf="matDatepicker.opened" matDatepickerToggleIcon style="font-size: 26px; position: relative; top: 6px"
      >keyboard_arrow_down</mat-icon
    >
  </mat-datepicker-toggle>

  <mat-datepicker
    #matDatepicker
    [opened]="model.getAdditional('opened', false)"
    [startAt]="model.focusedDate"
    [startView]="model.getAdditional('startView', 'month')"
    [touchUi]="model.getAdditional('touchUi', false)"
    (closed)="onCustomEvent($event, 'closed')"
    (monthSelected)="onCustomEvent($event, 'monthSelected')"
    (opened)="onCustomEvent($event, 'opened')"
    (yearSelected)="onCustomEvent($event, 'yearSelected')"
  ></mat-datepicker>

  <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
</mat-form-field>
